// extracted by mini-css-extract-plugin
export default {"wrapper":"NewsList_wrapper__3fbUg","font-title":"NewsList_font-title__ncj7z"};